import React, {Component, PropTypes} from 'react';

export default class SIMZoomerIcon extends Component {

  static renderReset () {
    return (
      <svg className="zoomer__icon--reset" viewBox="0 0 64 64">
        <path d="M32,64C14.357,64,0,49.643,0,31.998l0.018-0.436l7.474,0.161l-0.018,0.436C7.478,45.521,18.479,56.522,32,56.522
		s24.522-11.001,24.522-24.524c0-13.521-11.001-24.52-24.522-24.52c-6.247,0-17.577,1.944-23.266,14.97l-6.85-2.994
		C9.548,1.895,25.497,0,32,0c17.643,0,32,14.355,32,31.998C64,49.643,49.643,64,32,64z"/>
        <polyline points="16.865,22.1 2.285,24.15 0.259,9.749 	"/>
      </svg>
    );
  }

  static renderPlus () {
    return (
      <svg className="zoomer__icon--plus" viewBox="0 0 64 64">
        <rect y="29" width="64" height="6"/>
        <rect x="29" width="6" height="64"/>
      </svg>
    );
  }

  static renderMinus () {
    return (
      <svg className="zoomer__icon--minus" viewBox="0 0 64 64">
        <rect x="0.001" y="29" width="64" height="6"/>
      </svg>
    );
  }

  render () {
    switch (this.props.type) {
      case 'reset':
        return SIMZoomerIcon.renderReset();
      case 'plus':
        return SIMZoomerIcon.renderPlus();
      case 'minus':
        return SIMZoomerIcon.renderMinus();
    }
  }
}



// WEBPACK FOOTER //
// ./frontend/react/sim/core/components/zoomer/icon.jsx